import { getSelectedPosID } from 'reducers/PointsOfSale';
import { getCurrentSalesDocument } from 'reducers/Payments';
import { ShoppingCart } from 'types/ShoppingCart';
import {
  getDiscountReasonByOrderIndex,
  getProductsInShoppingCart,
} from 'reducers/ShoppingCart';
import { getVatRates } from 'reducers/vatRatesDB';
import { round } from 'utils';

import { EFSTARequestTransaction } from '../../types/requestType';

type ESR = Required<Required<EFSTARequestTransaction['Tra']>['ESR']>;

type PosA = ESR['PosA'];

function getPosA(state): PosA {
  const shoppingCart: ShoppingCart = getProductsInShoppingCart(state);
  const vatRates = getVatRates(state);

  const positions: PosA = [];
  shoppingCart.forEach(item => {
    positions.push({
      _: 'Pos',
      Dsc: item.name,
      Pri: String(item.finalPriceWithVAT),
      ...(item.computed ? { PTY: 'Dep' } : undefined),
      Amt: round(Number(item.amount) * Number(item.finalPriceWithVAT)),
      Qty: String(item.amount),
      ID: String(item.productID),
      QtyU: item.unit,
      TaxG:
        vatRates.find(rate => Number(rate.id) === Number(item.vatrateID))
          ?.code ?? '?',
    });
    if (item.totalDiscountAmountWithVAT) {
      positions.push({
        _: 'Mod',
        Amt: `-${Number(item.totalDiscountAmountWithVAT).toFixed(2)}`,
        Dsc: getDiscountReasonByOrderIndex(item.orderIndex)(state)?.name,
        PN: String(item.rowNumber),
      });
    }
  });
  return positions;
}

export const getCurrentTransaction = (
  state,
): EFSTARequestTransaction['Tra'] => {
  const posID = getSelectedPosID(state);
  const salesDoc = getCurrentSalesDocument(state);
  return {
    ESR: {
      TL: String(posID),
      TN: String(salesDoc.number ?? salesDoc.invoiceNo ?? 'new'),
      PosA: getPosA(state),
      Test: '0',
    },
  };
};
